import { useCallback, useEffect, useState } from 'react'
import {
  readNavbarClockPreferences,
  resetNavbarClockPreferences,
  subscribeNavbarClockPreferences,
  writeNavbarClockPreferences,
} from '../lib/navbarClockPreferences'

export function useNavbarClockPreferences() {
  const [preferences, setPreferences] = useState(readNavbarClockPreferences)

  useEffect(() => subscribeNavbarClockPreferences(setPreferences), [])

  const updatePreferences = useCallback(patch => {
    const current = readNavbarClockPreferences()
    const changes = typeof patch === 'function' ? patch(current) : patch
    return writeNavbarClockPreferences({
      ...current,
      ...changes,
    })
  }, [])

  const resetPreferences = useCallback(() => resetNavbarClockPreferences(), [])

  return {
    preferences,
    updatePreferences,
    resetPreferences,
  }
}
